import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { LinkedInMessageLink } from "@/features/contact/LinkedInMessageLink";
import { headingText } from "@/lib/heading";

type Props = {
  title?: string;
  children?: ReactNode;
};

export function CtaBand({
  title = "Write to me about prediction in production",
  children,
}: Props) {
  return (
    <section className="cta-band wrap">
      <h2>{headingText(title)}</h2>
      {children ?? (
        <p>
          Workshops, architecture conversations, and product design for teams
          who need reliable predictions that stay with the human.
        </p>
      )}
      <div className="hero-actions">
        <Link className="button" to="/work-with-jay">
          Work with Jay
        </Link>
        <LinkedInMessageLink className="button-secondary" />
      </div>
    </section>
  );
}
